import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface StatusBadgeProps {
  status: string
  variant?: 'lead' | 'qualification' | 'sentiment' | 'user' | 'default'
  className?: string
}

const statusStyles: Record<string, Record<string, string>> = {
  lead: {
    new: 'bg-blue-100 text-blue-800',
    contacted: 'bg-yellow-100 text-yellow-800',
    qualified: 'bg-green-100 text-green-800',
    unqualified: 'bg-gray-100 text-gray-800',
    converted: 'bg-purple-100 text-purple-800',
    lost: 'bg-red-100 text-red-800',
    low_priority: 'bg-amber-100 text-amber-800',
  },
  qualification: {
    pending: 'bg-gray-100 text-gray-800',
    in_progress: 'bg-blue-100 text-blue-800',
    qualified: 'bg-green-100 text-green-800',
    disqualified: 'bg-red-100 text-red-800',
    low_priority: 'bg-amber-100 text-amber-800',
    needs_review: 'bg-orange-100 text-orange-800',
    existing_client: 'bg-indigo-100 text-indigo-800',
  },
  sentiment: {
    positive: 'bg-green-100 text-green-800',
    neutral: 'bg-gray-100 text-gray-800',
    negative: 'bg-red-100 text-red-800',
  },
  user: {
    admin: 'bg-purple-100 text-purple-800',
    standard: 'bg-blue-100 text-blue-800',
    active: 'bg-green-100 text-green-800',
    inactive: 'bg-gray-100 text-gray-800',
  },
  default: {
    active: 'bg-green-100 text-green-800',
    inactive: 'bg-gray-100 text-gray-800',
    pending: 'bg-yellow-100 text-yellow-800',
    error: 'bg-red-100 text-red-800',
  },
}

export function StatusBadge({ status, variant = 'default', className }: StatusBadgeProps) {
  const normalizedStatus = status.toLowerCase().replace(/\s+/g, '_')
  const styles = statusStyles[variant]?.[normalizedStatus] || statusStyles.default[normalizedStatus] || 'bg-gray-100 text-gray-800'

  const displayText = status
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())

  return (
    <Badge
      variant="outline"
      className={cn('border-0 font-medium', styles, className)}
    >
      {displayText}
    </Badge>
  )
}
